<template>
<!--每月升级数量-->
  <dv-border-box-7>
    <div class="item" style="height:42vh;">
      <div class="font-weight font-s">{{title}}</div>
      <div class="p-tb" id="monthEchart" style="height:100%;width:100%;"></div>
    </div>
  </dv-border-box-7>
</template>

<script>
export default {
  name: "andon-right",
  props: {
    mttr: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle:{
      type: String,
      default: function () {
        return "MTTR";
      },
    },
  },
  data() {
    return {
      title:this.headTitle,
      mttrs: this.mttr,
      platosMttr: undefined,
    };
  },
  watch: {
    mttr: {
      handler: function (val, oldVal) {
        this.mttrs = val;
        this.mttrEchart();
      },
      deep: true,
    }
  },
  mounted() {
    var _this = this;
  },
  methods: {
    mttrEchart() {
      var _this = this;
      var dataSet = _this.mttrs;

      let daset = [];
      let daval = [];
      dataSet.forEach((m) => {
        var count = m["issueCount"];
        daset.push(m["periodValue"] + "月");
        daval.push(count);
      });

      var echart = this.$echarts.init(document.getElementById("monthEchart"));

      var option = {
        grid: {
          bottom: "35",
          top: -60,
          x: 50,
          y:-40
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["MTTR"],
          textStyle: {
            color: "#ffffff",
          },
        },
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: daset,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
              interval: 0,
              rotate: 40,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value} 个",
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: 12,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            color: ["#3398DB"],
            name: "数量",
            type: "bar",
            data: daval,
            barGap: "-100%",
          }
        ],
      };

      echart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        echart.resize();
      });

      if (_this.platosMttr) {
        clearInterval(_this.platosMttr);
      }

      var index = 0; //显示tooltip,播放所在下标
      _this.platosMttr = setInterval(function () {
        echart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= daset.length) {
          index = 0;
        }
      }, 2000);
    },
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.2rem 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/escalation/component/month-total.vue